
export default {
    name: 'TwigMessages',
    computed: {
        errorMessages() {
            return window.Store?.messages?.error || []
        },
        warningMessages() {
            return window.Store?.messages?.warning || []
        },
        infoMessages() {
            return window.Store?.messages?.info || []
        },
        messageTypes() {
            return [
                { type: 'error', messages: this.errorMessages },
                { type: 'warning', messages: this.warningMessages },
                { type: 'info', messages: this.infoMessages },
            ].filter((m) => m.messages.length > 0)
        },
    },
}
